// @TODO: This function is a copy and paste of what is used in the services repo, this logic should be placed in a shared packages repo and imported from that
/**
 * Sums an array of floating point numbers (up to 2 digits of precision) without resulting in floating point rounding errors.
 * @param  {[number]} decimals - An array of mutable floating point numbers to be added together to avoid floating point rounding errors.
 *  @returns {number} Sum of the provided array of numbers.
 */
module.exports = (decimals) =>
  decimals.reduce((sum, decimal) => (Math.round(sum * 100) + Math.round(decimal * 100)) / 100, 0)
